import * as React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { JSONClipboardIconButton } from "components/common";
import { ButtonToolbar } from "components/bootstrap";
import IconButton from "components/common/IconButton";
const StyledButtonToolbar = styled(ButtonToolbar)(
  ({ theme }) => css`
    position: absolute;
    right: 1px;
    top: 0;
    max-height: 100%;
    background-color: ${theme.colors.table.row.backgroundHover};
  `
);
const LogViewRowActions = ({ message, onShowDetails }) => {
  const { t } = useTranslation("enterprise_search");
  return /* @__PURE__ */ React.createElement(StyledButtonToolbar, null, /* @__PURE__ */ React.createElement(JSONClipboardIconButton, { buttonTitle: t("log_view_row_actions.copy_message"), content: message }), /* @__PURE__ */ React.createElement(IconButton, { title: t("log_view_row_actions.open_message_details"), name: "open_in_full", onClick: onShowDetails }));
};
export default LogViewRowActions;
